@if (showCalendar() || showRangeSelector() || showCustomRangeSelector()) {
  <div class="tt-datepicker">
    @if (showRangeSelector()) {
      <div class="tt-datepicker_range-selector">
        <button
          ttButton
          [emphasis]="'regular'"
          [variant]="selected() === '3mo' ? 'primary' : 'transparent'"
          (click)="ucumSelectedChange('3mo')">
          {{ 'Datepicker.InMonths' | transloco: { months: 3 } }}
        </button>
        <button
          ttButton
          [emphasis]="'regular'"
          [variant]="selected() === '6mo' ? 'primary' : 'transparent'"
          (click)="ucumSelectedChange('6mo')">
          {{ 'Datepicker.InMonths' | transloco: { months: 6 } }}
        </button>
        <button
          ttButton
          [emphasis]="'regular'"
          [variant]="selected() === '9mo' ? 'primary' : 'transparent'"
          (click)="ucumSelectedChange('9mo')">
          {{ 'Datepicker.InMonths' | transloco: { months: 9 } }}
        </button>
        <button
          ttButton
          [emphasis]="'regular'"
          [variant]="selected() === '12mo' ? 'primary' : 'transparent'"
          (click)="ucumSelectedChange('12mo')">
          {{ 'Datepicker.InMonths' | transloco: { months: 12 } }}
        </button>
        <button
          ttButton
          [emphasis]="'regular'"
          [variant]="selected() === '24mo' ? 'primary' : 'transparent'"
          (click)="ucumSelectedChange('24mo')">
          {{ 'Datepicker.InMonths' | transloco: { months: 24 } }}
        </button>
        <button
          ttButton
          [emphasis]="'regular'"
          [variant]="selected() === '36mo' ? 'primary' : 'transparent'"
          (click)="ucumSelectedChange('36mo')">
          {{ 'Datepicker.InMonths' | transloco: { months: 36 } }}
        </button>
      </div>
    }
    @if (showCalendar()) {
      <mat-calendar
        class="tt-datepicker_calendar"
        [headerComponent]="DatePickerHeaderComponent"
        [minDate]="minDate()"
        [selected]="selectedDate()"
        [startAt]="startAt()"
        (selectedChange)="selectedChange($event)" />
    } @else if (showCustomRangeSelector()) {
      <mat-calendar
        class="tt-datepicker_calendar"
        [headerComponent]="DatePickerHeaderComponent"
        [minDate]="minDate()"
        [selected]="selectedRange()"
        [startAt]="startAt()"
        (selectedChange)="onRangeCalendarChange($event)" />
    }
  </div>
}
